import StyledContainer from "style/styledContainer"
import styled, { css } from "styled-components"

import { Row } from "style/preset"
import { ReactComponent as WalletSvg } from 'assets/svgs/wallet_Icon.svg'
import { ReactComponent as ArrowRightSvg } from 'assets/svgs/arrow_right.svg'
import DrawerWalletCom from "./Wallet/DrawerWalletCom"
import { useAppDispatch, useAppSelector } from "hooks/redux/hooks"
import { setWalletManageOpened, setWalletWinOpened } from "hooks/redux/slices/walletSlice"
import DrawerWalletManageCom from "./Wallet/DrawerWalletManageCom"
import { useCallback } from "react"

const WalletConnectCom = () => {
    const {walletWinOpened , walletManageOpened, isConnected} = useAppSelector((state) => state.wallet)
    const dispatch = useAppDispatch()

    const fnOpenPopWin = useCallback(() => {
        if(isConnected) {
            dispatch(setWalletManageOpened(true))
        } else {
            dispatch(setWalletWinOpened(true))
        }
    }, [dispatch, isConnected])


    return <StyledContainer>
        <WalletConnectWrap $active={isConnected} onClick={fnOpenPopWin}>
            <WalletSvg></WalletSvg>
            <Row $justifyContent="space-between" $mt="12px">
                <StyledContainer $fontSize="14px" $lineHeight="18px" $fontWeight5>
                    {isConnected ? '1 Wallet' : 'Connect'}<br/>{isConnected ? 'Connected' : 'Your Wallet'}
                </StyledContainer>
                <ArrowRightSvg></ArrowRightSvg>
            </Row>
        </WalletConnectWrap>
        <DrawerWalletCom open={walletWinOpened} closeChange={(isClosed) => dispatch(setWalletWinOpened(isClosed))}></DrawerWalletCom>
        <DrawerWalletManageCom open={walletManageOpened} closeChange={(isClosed) => dispatch(setWalletManageOpened(isClosed))}></DrawerWalletManageCom>
    </StyledContainer>
}

const WalletConnectWrap = styled(StyledContainer)<{$active: boolean}>`
    padding: 15px 15px 15px 20px;
    border-top: 1px dashed ${({$active}) => $active ? '#00CC0A': '#DCB93D'};
    border-bottom: 1px dashed ${({$active}) => $active ? '#00CC0A': '#DCB93D'};
    cursor: pointer;
    ${
        ({$active}) => $active ? css`
            background: linear-gradient(105deg, #C0FFC5, #EBFFEC,  #C0FFC5);
            border-top: 1px dashed '#00CC0A';
            border-bottom: 1px dashed '#00CC0A';
        `: css`
            background: linear-gradient(105deg, rgba(250, 252, 176, 0.77), rgba(253, 253, 216, 0.2), rgba(250, 252, 176, 0.77));
            border-top: 1px dashed '#DCB93D';
            border-bottom: 1px dashed '#DCB93D';
        `
    }
    background-size: 200%;
    &:hover {
        background-position: 80% 0; 
    }


    @media screen and (min-width: 1024px) {
        ${Row} {
            display: flex;
        }
    }
    @media screen and (max-width: 1024px) {
        padding: 15px 0 15px 0;
        display: flex;
        justify-content: center;
        align-items: center;
        ${Row} {
            display: none;
        }
    }
`

export default WalletConnectCom